import styled from 'styled-components';
import { SbForm } from 'uiCore';

export const DrawerFormStyled = styled(SbForm)`
  display: flex;
  flex-direction: column;
  flex: 1;

  .ant-form-item-label > label {
    color: ${({ theme }) => theme.colors.dark};
    font-weight: 500;
  }

  .ant-form-item {
    margin-bottom: 16px;
  }
`;

export const DrawerFooterStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const DrawerErrorStyled = styled.div`
  padding: 10px 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.warningBg};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  color: ${({ theme }) => theme.colors.warningMessage};
  font-size: 13px;
  margin-bottom: 16px;
`;
